export const SETSOURCELIST = "SETSOURCELIST";
export const SETSTAGELIST = "SETSTAGELIST";
export const SETVERTICALLIST = "SETVERTICALLIST";
export const SETSTATUSLIST = "SETSTATUSLIST";
export const SETTASKSTATUSLIST = "SETTASKSTATUSLIST";
export const SETUSERROLESLIST = "SETUSERROLESLIST";
export const SETROLEAUTHORIZATIONLIST = "SETROLEAUTHORIZATIONLIST";
export const SETAUTHORIZEDPAGES = "SETAUTHORIZEDPAGES";
export const SETUSERLIST = "SETUSERLIST";
export const SET_USER_DATA = "SET_USER_DATA";
export const SETADVANCESERIESLIST = "SETADVANCESERIESLIST";
export const SETADVANCESETTING = "SETADVANCESETTING";
export const SETACCOUNTLIST = "SETACCOUNTLIST";
export const SETPROJECTTYPELIST = "SETPROJECTTYPELIST";
export const SETPROJECTSTATUSLIST = "SETPROJECTSTATUSLIST";
export const SETDEPARTMENTLIST = "SETDEPARTMENTLIST";
export const SETDEPARTMENTDETAIL = "SETDEPARTMENTDETAIL";
export const SETTICKETLEVELLIST = "SETTICKETLEVELLIST";
export const SETTICKETPRIORITYLIST = "SETTICKETPRIORITYLIST";
export const SETTICKETSTATUSLIST = "SETTICKETSTATUSLIST";
export const CLEARDOC = "CLEARDOC";
export const SETNOTIFICATIONLIST = "SETNOTIFICATIONLIST";
export const SETHISTORYLIST = "SETHISTORYLIST";
export const SETTICKETREVIEWLIST = "SETTICKETREVIEWLIST";
export const SET_DIVISION_LIST = "SET_DIVISION_LIST";
export const SET_DIVISION_ADMIN_ACCESS_LIST = "SET_DIVISION_ADMIN_ACCESS_LIST";
export const SET_USER_EMAIL_LIST = "SET_USER_EMAIL_LIST";
export const SET_TIME_ZONES_LIST = "SET_TIME_ZONES_LIST";
export const SET_ROOT_CAUSE_LIST = "SET_ROOT_CAUSE_LIST";
export const SET_SKILLS_LIST = "SET_SKILLS_LIST";
export const SET_ORGANISATION_LEVELS_LIST = "SET_ORGANISATION_LEVELS_LIST";
export const SET_USER_DEPARTMENTS_LIST = "SET_USER_DEPARTMENTS_LIST";
export const SET_CLUSTERS_LIST = "SET_CLUSTERS_LIST";
export const SET_LEAVE_WFH_MASTER_LIST = "SET_LEAVE_WFH_MASTER_LIST";

